import { NgModule } from '@angular/core';
import { RouterModule} from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule} from '@angular/forms';
import { TableComponent } from './table/table.component';
import { PageComponent } from './page/page.component';
import { KeydownSearchDirective } from './keydown-search.directive';
import { TooltipModule} from '../ing/tooltip/tooltip';
import { ButtonModule} from "../ing/button/button";
import { ClipboardModule} from 'ngx-clipboard';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    TooltipModule,
    ButtonModule,
    ClipboardModule
  ],
  exports: [
    TableComponent,
    KeydownSearchDirective,
    PageComponent
  ],
  declarations: [TableComponent, PageComponent, KeydownSearchDirective]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/component/shared/shared.module.ts